import React from 'react';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../components/general/Checkbox';

const ITEM_KEYS = ['spelling', 'layout', 'quality', 'delay'] as const;

const OptionZenSection: React.FC = () => {
    const { t } = useTranslation('optionZen');

    return (
        <OptionZenCard>
            <OptionZenHeader>
                <div
                    style={{
                        display: "flex",
                        padding: "0.4rem 0.6rem",
                        alignItems: "center",
                        gap: "0.5rem",
                        borderRadius: "8px",
                    }}
                >
                    {/* <Checkbox /> */}
                    <OptionZenTitleBlock>
                        <OptionZenTitle>{t('headerTitle')}</OptionZenTitle>
                    </OptionZenTitleBlock>
                    {/* <OptionZenIcon>☯</OptionZenIcon> */}
                </div>
            </OptionZenHeader>
            <OptionZenBody>
                <OptionZenBodyTitle>{t('listHeader')}</OptionZenBodyTitle>
                {ITEM_KEYS.map((key) => {
                    const text = t(`items.${key}`);
                    const colonIndex = text.indexOf(':');
                    const label = colonIndex !== -1 ? text.slice(0, colonIndex + 1) : null;
                    const rest = colonIndex !== -1 ? text.slice(colonIndex + 1) : text;
                    return (
                        <OptionZenItem key={key}>
                            <OptionZenCheck>✓</OptionZenCheck>
                            <span>
                                {label && <OptionZenLabel>{label}</OptionZenLabel>}
                                <OptionZenRegular>{rest}</OptionZenRegular>
                            </span>
                        </OptionZenItem>
                    );
                })}
                <CartButton>
                    <CartIconCircle>
                        <img src="/svg/pc-cart-white.svg" width={18} height={18} alt="" />
                    </CartIconCircle>
                    <span>{t('cartButton')}</span>
                </CartButton>
                <FootnoteText>{t('footnote')}</FootnoteText>
            </OptionZenBody>
        </OptionZenCard>
    );
};

const OptionZenCard = styled.div`
    margin-top: 0.75rem;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
`;

const OptionZenHeader = styled.div`
    margin: 0.5rem;
`;

const OptionZenBadge = styled.div`
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    background-color: #8BC34A;
`;

const OptionZenTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const OptionZenTitle = styled.span`
    font-size: 13px;
    font-weight: 700;
    font-family: 'Lora', serif;
    color: #111;
`;

const OptionZenSubtitle = styled.span`
    font-size: 12px;
    color: #111;
`;

const OptionZenIcon = styled.div`
    font-size: 20px;
    color: #9eaeb0;
    flex-shrink: 0;
`;

const OptionZenBody = styled.div`
    padding: 0.25rem 0.75rem 0.5rem;
`;

const OptionZenBodyTitle = styled.div`
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 0.25rem;
`;

const OptionZenItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.4rem;
    font-size: 11px;
    margin-bottom: 0.15rem;
`;

const OptionZenCheck = styled.span`
    color: #111;
    font-size: 12px;
`;

const CartButton = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    font-size: 11px;
    font-weight: 700;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: #111;
    cursor: pointer;
`;

const CartIconCircle = styled.div`
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    background-color: #111;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const FootnoteText = styled.p`
    font-size: 10px;
    font-style: italic;
    color: #888;
    margin-top: 0.35rem;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
`;

const OptionZenLabel = styled.span`
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 700;
`;

const OptionZenRegular = styled.span`
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
`;

export default OptionZenSection;
